import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout as logoutAPI } from '../../apis/apiHandler';
import { logout } from '../../slice/authSlice';
import Swal from 'sweetalert2';
import ChangePassword from '../changePassword/ChangePassword';

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.auth.userInfo);
    const [isModelOpen, setIsModelOpen] = useState(false)

    const handleChangePassword = () => setIsModelOpen(true)
    const handleCloseModal = () => setIsModelOpen(false)

    const handleMenuToggle = () => {
        document.body.classList.toggle('sidebar-enable');
    }

    const handleLogout = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will be logged out of your account',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0e834f',
            cancelButtonColor: '#f1556c',
            confirmButtonText: 'Yes, logout!'
        });

        if (result.isConfirmed) {
            try {
                const response = await logoutAPI();
                if (response?.code === 200) {
                    dispatch(logout());
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        backdrop: false,
                        title: response?.message,
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(() => {
                        navigate('/');
                    });
                }
            } catch (error) {
                console.error('Logout error:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    backdrop: false,
                    title: 'Logout failed. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                });
            }
        }
    }
    return (
        <>
            <div className="navbar-custom">
                <div className="container-fluid">
                    <ul className="list-unstyled topnav-menu float-end mb-0">
                        <li className="dropdown notification-list topbar-dropdown">
                            <a
                                className="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-haspopup="false"
                                aria-expanded="false"
                            >
                                <img
                                    src={userInfo?.image ? userInfo?.image : process.env.PUBLIC_URL + '/assets/avatar.png'}
                                    // onError={(e) => {
                                    //     e.target.onerror = null;
                                    //     e.target.src = userIcon;
                                    // }}
                                    alt="user-image"
                                    className="rounded-circle"
                                />
                                <span className="pro-user-name ms-1">
                                    {userInfo?.full_name} <i className="mdi mdi-chevron-down" />
                                </span>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end profile-dropdown ">
                                {/* item*/}
                                <div className="dropdown-header noti-title">
                                    <h6 className="text-overflow m-0">Welcome !</h6>
                                </div>
                                {/* item*/}
                                {/* <Link
                  to={""}
                  className="dropdown-item notify-item"
                >
                  <i className="fe-user" />
                  <span>My Account</span>
                </Link> */}
                                {/* item*/}
                                {/* <a
                href="javascript:void(0);"
                className="dropdown-item notify-item"
              >
                <i className="fe-settings" />
                <span>Settings</span>
              </a> */}
                                {/* item*/}
                                <Link
                                    onClick={handleChangePassword}
                                    className="dropdown-item notify-item"
                                >
                                    <i className="fe-lock" />
                                    <span>Change Password</span>
                                </Link>
                                <div className="dropdown-divider" />
                                {/* item*/}
                                <Link
                                    className="dropdown-item notify-item"
                                    onClick={handleLogout}
                                >
                                    <i className="fe-log-out" />
                                    <span>Logout</span>
                                </Link>
                            </div>
                        </li>
                    </ul>
                    {/* LOGO */}
                    <div className="logo-box">
                        <a href="#" className="logo logo-dark text-center">
                            <span className="logo-sm">
                                <img src={process.env.PUBLIC_URL + "/logo192.png"} alt="logo" style={{ height: "4vh", width: "4vw" }} />
                                {/* <span class="logo-lg-text-light">UBold</span> */}
                            </span>
                            <span className="logo-lg">
                                <img src={process.env.PUBLIC_URL + "/logo192.png"} alt="logo" style={{ height: "10vh", width: "17vw" }} />
                                {/* <span class="logo-lg-text-light">U</span> */}
                            </span>
                        </a>
                        <Link to="/dashboard" className="logo logo-light text-center">
                            <span className="logo-sm">
                                <img src={process.env.PUBLIC_URL + "/logo192.png"} alt="logo" style={{ height: "9vh", width: "17vw" }} />
                            </span>
                            <span className="logo-lg">
                                <img src={process.env.PUBLIC_URL + "/logo192.png"} alt="logo" style={{ height: "7.2vh", width: "4.2vw" }} />
                            </span>
                        </Link>
                    </div>
                    <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
                        <li>
                            <button className="button-menu-mobile waves-effect waves-light" onClick={handleMenuToggle}>
                                <i className="fe-menu" />
                            </button>
                        </li>
                        <li>
                            {/* Mobile menu toggle (Horizontal Layout)*/}
                            <a
                                href="#"
                                className="navbar-toggle nav-link"
                                data-bs-toggle="collapse"
                                data-bs-target="#topnav-menu-content"
                            >
                                <div className="lines">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </a>
                            {/* End mobile menu toggle*/}
                        </li>

                    </ul>
                    {/* <div className="clearfix" /> */}
                </div>
            </div>

            <ChangePassword
                isOpen={isModelOpen}
                onClose={handleCloseModal}
            />
        </>
    )
}

export default Header;